import { MaterialItemCategory } from "../MaterialItemCategory/MaterialItemCategory.type";
import { ApiCallState, PagedData } from "../Utils";

export type MaterialSubCategory = {
  id?: number;
  key: number;
  description: string;
  code: number;
  material_item_category?: MaterialItemCategory;
};

export type MaterialSubCategoryStateTypes = {
  fetchAll: ApiCallState<MaterialSubCategory[]>;
  fetchOne: ApiCallState<MaterialSubCategory | {}>;
  fetchPaged: ApiCallState<PagedData<MaterialSubCategory[]>>;
};

export const MaterialSubCategoryActionTypes = {
  FETCH_ALL_MATERIAL_SUB_CATEGORY: "FETCH_ALL_MATERIAL_SUB_CATEGORY",
  FETCH_ALL_MATERIAL_SUB_CATEGORY_RESET:
    "FETCH_ALL_MATERIAL_SUB_CATEGORY_RESET",
  FETCH_ALL_MATERIAL_SUB_CATEGORY_FAILURE:
    "FETCH_ALL_MATERIAL_SUB_CATEGORY_FAILURE",
  FETCH_ALL_MATERIAL_SUB_CATEGORY_SUCCESS:
    "FETCH_ALL_MATERIAL_SUB_CATEGORY_SUCCESS",

  FETCH_PAGED_MATERIAL_SUB_CATEGORY: "FETCH_PAGED_MATERIAL_SUB_CATEGORY",
  FETCH_PAGED_MATERIAL_SUB_CATEGORY_RESET:
    "FETCH_PAGED_MATERIAL_SUB_CATEGORY_RESET",
  FETCH_PAGED_MATERIAL_SUB_CATEGORY_FAILURE:
    "FETCH_PAGED_MATERIAL_SUB_CATEGORY_FAILURE",
  FETCH_PAGED_MATERIAL_SUB_CATEGORY_SUCCESS:
    "FETCH_PAGED_MATERIAL_SUB_CATEGORY_SUCCESS",

  FETCH_ONE_MATERIAL_SUB_CATEGORY: "FETCH_ONE_MATERIAL_SUB_CATEGORY",
  FETCH_ONE_MATERIAL_SUB_CATEGORY_RESET:
    "FETCH_ONE_MATERIAL_SUB_CATEGORY_RESET",
  FETCH_ONE_MATERIAL_SUB_CATEGORY_FAILURE:
    "FETCH_ONE_MATERIAL_SUB_CATEGORY_FAILURE",
  FETCH_ONE_MATERIAL_SUB_CATEGORY_SUCCESS:
    "FETCH_ONE_MATERIAL_SUB_CATEGORY_SUCCESS",
};
